var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.action
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("pickField"),
                visible: _vm.fieldDialogFormVisible
              }
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("pickFieldForContact")))]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.continueHandleSelectEndpointForEmail(
                            "to",
                            _vm.inProgressContact,
                            _vm.inProgressChannelEndpoint
                          )
                        }
                      }
                    },
                    [_vm._v("To")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.continueHandleSelectEndpointForEmail(
                            "bcc",
                            _vm.inProgressContact,
                            _vm.inProgressChannelEndpoint
                          )
                        }
                      }
                    },
                    [_vm._v("BCC")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.continueHandleSelectEndpointForEmail(
                            "cc",
                            _vm.inProgressContact,
                            _vm.inProgressChannelEndpoint
                          )
                        }
                      }
                    },
                    [_vm._v("CC")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { ref: "toolbar", staticClass: "toolbar", attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                [
                  _vm.originalAction
                    ? [
                        _c(
                          "el-card",
                          { staticClass: "no-shadow mb-5 el-card-sm-padding" },
                          [
                            _c(
                              "div",
                              { staticClass: "mb-5" },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "primary", size: "mini" } },
                                  [_vm._v(_vm._s(_vm.$t("retryNotice")))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "mb-5 fs-13" }, [
                                _c("b", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$tc("originalAction")) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-13" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("to")) +
                                      ": " +
                                      _vm._s(
                                        _vm.originalAction[0].metadata
                                          .channels[0].channel === "MAIL"
                                          ? _vm.formatMailTo(
                                              _vm.originalAction[0].metadata
                                                .channels[0].to
                                            )
                                          : _vm.originalAction[0].metadata
                                              .channels[0].to
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("channel")) +
                                      ": " +
                                      _vm._s(
                                        _vm.originalAction[0].metadata
                                          .channels[0].channel
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "disp-flex justify-content-between" },
                    [
                      _c("div", [
                        _c("div", { staticClass: "mb-10" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                "align-items": "center",
                                gap: "4px"
                              }
                            },
                            [
                              _vm.action && _vm.action.status === "OPEN"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        loading: _vm.isExecutingAction,
                                        type: "success",
                                        disabled:
                                          !_vm.action ||
                                          !_vm.editable ||
                                          !_vm.canBeExecutedManually.valid ||
                                          !_vm.formValid ||
                                          (_vm.isHandlingAction &&
                                            !_vm.isExecutingAction)
                                      },
                                      on: { click: _vm.onExecute }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("executeAction")) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.env !== "production"
                                ? [
                                    _vm.action && _vm.action.status === "OPEN"
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                              disabled:
                                                !_vm.action ||
                                                !_vm.editable ||
                                                (_vm.isHandlingAction &&
                                                  !_vm.ismarkingAsDone)
                                            },
                                            on: { click: _vm.onMarkAsDone }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.$t("markAsDone")) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.action && _vm.action.status === "OPEN"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "warning",
                                        loading: _vm.isCancelingAction,
                                        disabled:
                                          !_vm.action ||
                                          !_vm.editable ||
                                          (_vm.isHandlingAction &&
                                            !_vm.isCancelingAction)
                                      },
                                      on: { click: _vm.onCancel }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("cancelAction")) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    disabled:
                                      !_vm.action ||
                                      !_vm.editable ||
                                      _vm.isHandlingAction ||
                                      !_vm.isDirty
                                  },
                                  on: { click: _vm.onSaveChanges }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("saveChanges")) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.action.status === "DRAFT"
                                ? _c(
                                    "loading-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        execute: _vm.forceCancelAction
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "forcedCancelSelectedActions"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.action.status === "CANCELED" ||
                              _vm.action.status === "DRAFT"
                                ? _c(
                                    "loading-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        execute: _vm.forceOpenAction
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("forcedOpenSelectedActions")
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("extra-actions")
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.canBeExecutedManually.valid
                          ? _c("div", [
                              _c("div", { staticClass: "disp-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "mr-5" },
                                  [
                                    _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v(
                                        " ⚠️ " +
                                          _vm._s(
                                            _vm.canBeExecutedManually.error
                                          )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentRecipient &&
                        _vm.currentRecipient.dunning_is_dirty
                          ? _c("div", [
                              _c("div", { staticClass: "disp-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "mr-5" },
                                  [
                                    _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v(
                                        " ⚠️ " +
                                          _vm._s(_vm.$t("recipientDirty")) +
                                          " "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.actionDetailRightPanelCollapsed
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleRightPanel(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticStyle: { float: "right" } },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                transform: "rotate(180deg)"
                                              },
                                              attrs: {
                                                viewBox: "0 0 1024 1024",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "17",
                                                height: "17"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                staticStyle: { fill: "white" },
                                                attrs: {
                                                  d:
                                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleRightPanel(true)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticStyle: { float: "right" } },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 1024 1024",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "17",
                                                height: "17"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                staticStyle: { fill: "white" },
                                                attrs: {
                                                  d:
                                                    "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { style: _vm.modalContentStyle, attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.mainPanelWidth } },
                [
                  _c(
                    "el-card",
                    { staticClass: "no-shadow el-card-sm-padding" },
                    [
                      _vm.componentType === "EMAIL"
                        ? _c(
                            "div",
                            [
                              _c("email-form", {
                                ref: "emailForm",
                                attrs: {
                                  editable: _vm.editable,
                                  "suggested-to": _vm.suggestedTo,
                                  "email-addresses-from": _vm.emailAddressFrom
                                },
                                on: { input: _vm.onInput },
                                model: {
                                  value: _vm.emailForm,
                                  callback: function($$v) {
                                    _vm.emailForm = $$v
                                  },
                                  expression: "emailForm"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.componentType === "MAIL"
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "mb-20" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "labelStyleLarge mt-5 mb-10"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("sender")) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.fromAddressFull
                                    ? [
                                        _c(
                                          "el-form",
                                          {
                                            ref: "fromMailFormFull",
                                            staticClass: "miniForm",
                                            attrs: {
                                              inline: true,
                                              model: _vm.fromMailFormFull
                                            }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.street_name"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "312px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormFull
                                                        .streetName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormFull,
                                                        "streetName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormFull.streetName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.street_number"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "50px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormFull
                                                        .streetNumber,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormFull,
                                                        "streetNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormFull.streetNumber"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.post_box"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "50px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormFull
                                                        .postBox,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormFull,
                                                        "postBox",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormFull.postBox"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.city"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "170px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormFull.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormFull,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormFull.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.zip_code"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "70px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormFull
                                                        .zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormFull,
                                                        "zipCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormFull.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.city"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "120px"
                                                  },
                                                  attrs: {
                                                    value: _vm.$translate.iso_country_code(
                                                      _vm.fromMailFormFull
                                                        .iso_country_code
                                                    ),
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "el-form",
                                          {
                                            ref: "fromMailFormMinimal",
                                            staticClass: "miniForm",
                                            attrs: {
                                              model: _vm.fromMailFormMinimal,
                                              inline: true
                                            }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t("addressLine")
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: { size: "mini" },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormMinimal
                                                        .addressLine,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormMinimal,
                                                        "addressLine",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormMinimal.addressLine"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.city"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "170px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormMinimal
                                                        .city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormMinimal,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormMinimal.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.zip_code"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "70px"
                                                  },
                                                  attrs: {
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.fromMailFormMinimal
                                                        .zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fromMailFormMinimal,
                                                        "zipCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fromMailFormMinimal.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.country"
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "120px"
                                                  },
                                                  attrs: {
                                                    value: _vm.$translate.iso_country_code(
                                                      _vm.fromMailFormMinimal
                                                        .iso_country_code
                                                    ),
                                                    disabled: true,
                                                    size: "mini"
                                                  },
                                                  on: { input: _vm.onInput }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-20" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "labelStyleLarge mt-5 mb-10"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("to")) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.toAddressFull
                                    ? [
                                        _c(
                                          "el-form",
                                          {
                                            ref: "toMailFormFull",
                                            attrs: {
                                              inline: true,
                                              model: _vm.toMailFormFull,
                                              rules: _vm.toMailFormFullRules
                                            }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.company_name"
                                                  ),
                                                  prop: "companyName"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "302px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull
                                                        .companyName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "companyName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.companyName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.street_name"
                                                  ),
                                                  prop: "streetName"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "302px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull
                                                        .streetName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "streetName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.streetName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.street_number"
                                                  ),
                                                  prop: "streetNumber"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "60px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull
                                                        .streetNumber,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "streetNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.streetNumber"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.post_box"
                                                  ),
                                                  prop: "postBox"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "50px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull
                                                        .postBox,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "postBox",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.postBox"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.city"
                                                  ),
                                                  prop: "city"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "170px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.zip_code"
                                                  ),
                                                  prop: "zipCode"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "60px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormFull
                                                        .zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormFull,
                                                        "zipCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormFull.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.country"
                                                  ),
                                                  prop: "iso_country_code"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: { size: "mini" },
                                                    on: { change: _vm.onInput },
                                                    model: {
                                                      value:
                                                        _vm.toMailFormFull
                                                          .iso_country_code,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.toMailFormFull,
                                                          "iso_country_code",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "toMailFormFull.iso_country_code"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.countries,
                                                    function(country, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: country.name,
                                                          value: country.code
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "el-form",
                                          {
                                            ref: "toMailFormMinimal",
                                            attrs: {
                                              model: _vm.toMailFormMinimal,
                                              inline: true,
                                              rules: _vm.toMailFormMinimalRules
                                            }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.company_name"
                                                  ),
                                                  prop: "companyName"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "302px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormMinimal
                                                        .companyName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormMinimal,
                                                        "companyName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormMinimal.companyName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t("addressLine"),
                                                  prop: "addressLine"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "478px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormMinimal
                                                        .addressLine,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormMinimal,
                                                        "addressLine",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormMinimal.addressLine"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.city"
                                                  ),
                                                  prop: "city"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "170px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormMinimal
                                                        .city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormMinimal,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormMinimal.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.zip_code"
                                                  ),
                                                  prop: "zipCode"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "70px"
                                                  },
                                                  attrs: { size: "mini" },
                                                  on: { input: _vm.onInput },
                                                  model: {
                                                    value:
                                                      _vm.toMailFormMinimal
                                                        .zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.toMailFormMinimal,
                                                        "zipCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "toMailFormMinimal.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "action_detail.country"
                                                  ),
                                                  prop: "iso_country_code"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: { size: "mini" },
                                                    on: { change: _vm.onInput },
                                                    model: {
                                                      value:
                                                        _vm.toMailFormMinimal
                                                          .iso_country_code,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.toMailFormMinimal,
                                                          "iso_country_code",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "toMailFormMinimal.iso_country_code"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.countries,
                                                    function(country, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: country.name,
                                                          value: country.code
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("h3", { staticClass: "mb-10" }, [
                                _c("b", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("settings")) + "  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                {
                                  staticClass: "mr-10",
                                  attrs: { type: "warning" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        value:
                                          _vm.action.metadata.channels[0]
                                            .registered,
                                        disabled: !_vm.canEnableRegistered
                                      },
                                      on: { change: _vm.handleRegisteredChange }
                                    },
                                    [
                                      !_vm.canEnableRegistered
                                        ? _c("i", {
                                            staticClass: "el-icon-lock"
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("letterItems.registered")
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                {
                                  staticClass: "mr-10",
                                  attrs: { type: "warning" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        value:
                                          _vm.action.metadata.channels[0]
                                            .add_front_page,
                                        disabled: true
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("letterItems.addFrontPage")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                {
                                  staticClass: "mr-10",
                                  attrs: { type: "warning" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        value:
                                          _vm.action.metadata.channels[0]
                                            .perforation,
                                        disabled: true
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("letterItems.performation")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-10" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("letterItems.Urgence")) + ": "
                                  )
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.action.metadata.channels[0].urgency
                                        ? _vm.action.metadata.channels[0]
                                            .urgency
                                        : "NA"
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-20" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("letterItems.printMode")) +
                                      ": "
                                  )
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.action.metadata.channels[0].print_mode
                                        ? _vm.action.metadata.channels[0]
                                            .print_mode
                                        : "NA"
                                    )
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.componentType === "SMS"
                        ? _c(
                            "el-form",
                            {
                              ref: "smsForm",
                              attrs: {
                                model: _vm.smsForm,
                                rules: _vm.smsFormRules,
                                "label-width": "140px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("to"), prop: "to" } },
                                [
                                  _c("vue-tel-input", {
                                    attrs: { mode: "international" },
                                    on: {
                                      input: _vm.onSmsInput,
                                      validate: _vm.onSmsValidate
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "arrow-icon",
                                          fn: function() {
                                            return [_c("span", [_vm._v("▼")])]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2680791877
                                    ),
                                    model: {
                                      value: _vm.smsForm.to,
                                      callback: function($$v) {
                                        _vm.$set(_vm.smsForm, "to", $$v)
                                      },
                                      expression: "smsForm.to"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.smsToInvalid
                                    ? _c("p", { staticClass: "input-help" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "validator.action.sms.to.is_invalid"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.action &&
                                  _vm.action.channel_endpoint_by_reference &&
                                  _vm.action.channel_endpoint_by_reference
                                    .endpoint !== _vm.smsForm.to
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.useChannelEndpoint(
                                                "to"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("svg-icon", {
                                            staticStyle: {
                                              color: "#fff",
                                              "font-size": "11px"
                                            },
                                            attrs: {
                                              "icon-class": "sync-alt-solid"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.componentType === "PEPPOL"
                        ? _c(
                            "el-form",
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "mb-20",
                                  attrs: { shadow: "never" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "labelStyleLarge" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "ActionDetail.peppol.documentInfo"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c("el-col", { attrs: { span: 12 } }, [
                                        _c("div", { staticClass: "mb-10" }, [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted mb-5" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ActionDetail.peppol.documentId"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fw-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.peppolDocForm
                                                    .document_id || "-"
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("el-col", { attrs: { span: 12 } }, [
                                        _c("div", { staticClass: "mb-10" }, [
                                          _c(
                                            "div",
                                            { staticClass: "text-muted mb-5" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ActionDetail.peppol.documentType"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fw-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.peppolDocForm
                                                    .document_type || "-"
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "mb-20", attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-card",
                                        { attrs: { shadow: "never" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "clearfix",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "labelStyleLarge"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("sender"))
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.partyName"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "fw-bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.fromPeppolForm
                                                      .party_name || "-"
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.vat"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fromPeppolForm
                                                    .vat_number || "-"
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.identifier"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fromPeppolForm
                                                    .peppol_identifier || "-"
                                                )
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-card",
                                        { attrs: { shadow: "never" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "clearfix",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "labelStyleLarge"
                                                },
                                                [_vm._v(_vm._s(_vm.$t("to")))]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.partyName"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "fw-bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.toPeppolForm
                                                      .party_name || "-"
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.vat"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.toPeppolForm.vat_number ||
                                                    "-"
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mb-10" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-muted mb-5"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.identifier"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.toPeppolForm
                                                    .peppol_identifier || "-"
                                                )
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.peppolUblAttachment
                                ? _c(
                                    "el-card",
                                    {
                                      staticClass: "mb-20",
                                      attrs: { shadow: "never" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "clearfix",
                                          attrs: { slot: "header" },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "labelStyleLarge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "ActionDetail.peppol.ublXml"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticClass: "mr-10",
                                              attrs: { type: "info" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.peppolUblAttachment.name
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadPeppolUbl(
                                                    _vm.peppolUblAttachment
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("svg-icon", {
                                                attrs: {
                                                  "icon-class": "download"
                                                }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "ActionDetail.peppol.downloadUbl"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.componentType === "NONE" &&
                      _vm.action.message_code === "direct_debit"
                        ? _c("el-form", [
                            _c(
                              "div",
                              { staticClass: "mb-20" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "labelStyleLarge mt-5 mb-10" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "ActionDetail.directDebit.title"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form",
                                  {
                                    ref: "directDebitForm",
                                    staticClass: "miniForm",
                                    attrs: { model: _vm.directDebitForm }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "ActionDetail.directDebit.documentNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "170px" },
                                          attrs: {
                                            disabled: true,
                                            size: "mini"
                                          },
                                          model: {
                                            value:
                                              _vm.directDebitForm
                                                .document_number,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.directDebitForm,
                                                "document_number",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "directDebitForm.document_number"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "ActionDetail.directDebit.mandateId"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "170px" },
                                          attrs: {
                                            disabled: true,
                                            size: "mini"
                                          },
                                          model: {
                                            value:
                                              _vm.directDebitForm.mandate_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.directDebitForm,
                                                "mandate_id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "directDebitForm.mandate_id"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "ActionDetail.directDebit.amount"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "170px" },
                                          attrs: {
                                            disabled: true,
                                            size: "mini"
                                          },
                                          model: {
                                            value: _vm.directDebitForm.amount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.directDebitForm,
                                                "amount",
                                                $$v
                                              )
                                            },
                                            expression: "directDebitForm.amount"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          staticClass: "disp-flex justify-content-between",
                          attrs: { inline: true }
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _vm.tinymcecontent !== null
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: { click: _vm.handleDownloadSample }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("downloadExample")) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "disp-flex" },
                            [
                              !_vm.action.metadata.channels[0].body &&
                              _vm.action.metadata.channels[0].hasOwnProperty(
                                "template"
                              )
                                ? _c(
                                    "el-form",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: _vm.$t("language") }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                size: "mini",
                                                value: _vm.action.metadata.channels[0].template.locale.substring(
                                                  0,
                                                  2
                                                ),
                                                disabled: !_vm.editable
                                              },
                                              on: {
                                                change: _vm.handleLanguageChange
                                              }
                                            },
                                            _vm._l(_vm.languages, function(
                                              language,
                                              index
                                            ) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: _vm.$translate.language(
                                                    language.substring(0, 2)
                                                  ),
                                                  value: language.substring(
                                                    0,
                                                    2
                                                  )
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.availableChannels.length > 0
                                ? _c(
                                    "el-form",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: _vm.$t("channel") } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                size: "mini",
                                                value:
                                                  _vm.action.metadata
                                                    .channels[0].channel,
                                                disabled: !_vm.editable
                                              },
                                              on: {
                                                change: _vm.handleChannelChange
                                              }
                                            },
                                            _vm._l(
                                              _vm.availableChannels,
                                              function(channel, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: _vm.$translate.channel(
                                                      channel
                                                    ),
                                                    value: channel
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.action.metadata.channels[0].hasOwnProperty(
                                "template"
                              )
                                ? _c(
                                    "el-form",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "ActionDetail.template"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                size: "mini",
                                                value:
                                                  _vm.action.metadata
                                                    .channels[0].template
                                                    .template_id,
                                                disabled:
                                                  !_vm.editable ||
                                                  !_vm.canChangeTemplate
                                              },
                                              on: {
                                                change: _vm.handleTemplateChange
                                              }
                                            },
                                            _vm._l(_vm.templates, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item,
                                                attrs: {
                                                  label: item,
                                                  value: item
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse",
                        {
                          staticClass: "mb-20",
                          model: {
                            value: _vm.showDunningNoticeForm,
                            callback: function($$v) {
                              _vm.showDunningNoticeForm = $$v
                            },
                            expression: "showDunningNoticeForm"
                          }
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              attrs: {
                                name: "1",
                                disabled: !_vm.isManualAction
                              }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("span", { staticClass: "tab-label" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "action_detail.dunning_notice_customization"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tabs",
                                {
                                  model: {
                                    value: _vm.settingName,
                                    callback: function($$v) {
                                      _vm.settingName = $$v
                                    },
                                    expression: "settingName"
                                  }
                                },
                                [
                                  _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "action_detal.document_selection"
                                        ),
                                        name: "document_selection"
                                      }
                                    },
                                    [
                                      _vm.recipientRecord
                                        ? _c(
                                            "el-form",
                                            {
                                              ref: "dunningNoticeForm",
                                              staticClass:
                                                "dunning-notice-form__form",
                                              attrs: {
                                                model: _vm.dunningNoticeForm,
                                                rules:
                                                  _vm.dunningNoticeFormRules
                                              }
                                            },
                                            [
                                              _vm.recipientRecord
                                                .invoice_documents.length > 0.0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "dunning-notice-form__invoices",
                                                      attrs: {
                                                        prop: "invoices"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex justify-between"
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "payment_plan.create.invoices"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .dunningNoticeFormState
                                                            .showCheckAllInvoices
                                                            ? _c("el-switch", {
                                                                attrs: {
                                                                  "active-text": _vm.$t(
                                                                    "action_detail.show_all_invoices"
                                                                  ),
                                                                  "inactive-text": _vm.$t(
                                                                    "action_detail.show_open_invoices"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dunningNoticeFormState
                                                                      .showAllInvoices,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dunningNoticeFormState,
                                                                      "showAllInvoices",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dunningNoticeFormState.showAllInvoices"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-table",
                                                        {
                                                          ref: "invoicesTable",
                                                          attrs: {
                                                            data: _vm.invoices
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "invoice_number",
                                                                label: _vm.$t(
                                                                  "invoice_table.invoice_number"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "due_date",
                                                                label: _vm.$t(
                                                                  "invoice_table.due_date"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "open_amount",
                                                                label: _vm.$t(
                                                                  "invoice_table.open_amount"
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$formatter.toCurrency(
                                                                              scope
                                                                                .row
                                                                                .open_amount,
                                                                              scope
                                                                                .row
                                                                                .amount_currency
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                641494869
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "InvoiceTable.status"
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        scope
                                                                          .row
                                                                          .invoice_dispute
                                                                          .length >
                                                                        0
                                                                          ? [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "InvoiceTable.on_hold"
                                                                                    )
                                                                                  ) +
                                                                                  " <" +
                                                                                  _vm._s(
                                                                                    _vm.$translate.dispute_code(
                                                                                      scope
                                                                                        .row
                                                                                        .invoice_dispute[0]
                                                                                        .dispute_code_by_reference
                                                                                        .code
                                                                                    )
                                                                                  ) +
                                                                                  ">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                              )
                                                                            ]
                                                                          : _vm.isInPaymentPlan(
                                                                              scope.row
                                                                            )
                                                                          ? [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "InvoiceTable.in_payment_plan"
                                                                                    )
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                              )
                                                                            ]
                                                                          : _vm._e()
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                2077902034
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "InvoiceTable.dispute_until"
                                                                ),
                                                                width: "96"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        scope
                                                                          .row
                                                                          .invoice_dispute
                                                                          .length >
                                                                        0
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "parseTime"
                                                                                      )(
                                                                                        scope
                                                                                          .row
                                                                                          .invoice_dispute[0]
                                                                                          .until,
                                                                                        "{d}-{m}-{y}"
                                                                                      )
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                87886315
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.check_all_invoices"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm.isIndeterminateInvoices
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCheckAllInvoicesChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm.checkAllInvoices,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.checkAllInvoices = $$v
                                                                              },
                                                                              expression:
                                                                                "checkAllInvoices"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.selectedInvoices.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleCheckedInvoicesChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                4069775082
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.attach_all_invoices"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .isIndeterminateInvoicesAttachment,
                                                                              disabled:
                                                                                _vm.hasNoSelectedInvoicesWithAttachments
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleAttachAllInvoicesChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .checkAllInvoicesAttachment,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.dunningNoticeFormState,
                                                                                  "checkAllInvoicesAttachment",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "dunningNoticeFormState.checkAllInvoicesAttachment"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.attachedInvoices.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1,
                                                                              disabled: !scope
                                                                                .row
                                                                                .hasPdfAttachment
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleAttachedInvoicesChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                1141599288
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.recipientRecord.credit_notes
                                                .length > 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "create-account-overview__credit_notes",
                                                      attrs: {
                                                        prop: "creditNotes"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex justify-between"
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "payment_plan.create.credit_notes"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .dunningNoticeFormState
                                                            .howCheckAllCreditNotes
                                                            ? _c("el-switch", {
                                                                attrs: {
                                                                  "active-text": _vm.$t(
                                                                    "action_detail.show_all_credit_notes"
                                                                  ),
                                                                  "inactive-text": _vm.$t(
                                                                    "action_detail.show_open_credit_notes"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dunningNoticeFormState
                                                                      .showAllCreditNotes,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dunningNoticeFormState,
                                                                      "showAllCreditNotes",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dunningNoticeFormState.showAllCreditNotes"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-table",
                                                        {
                                                          ref:
                                                            "creditNotesTable",
                                                          attrs: {
                                                            data:
                                                              _vm.creditNotes
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "credit_note_number",
                                                                label: _vm.$t(
                                                                  "credit_note_table.credit_note_number"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "issue_date",
                                                                label: _vm.$t(
                                                                  "credit_note_table.issue_date"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "open_amount",
                                                                label: _vm.$t(
                                                                  "credit_note_table.open_amount"
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$formatter.toCurrency(
                                                                              scope
                                                                                .row
                                                                                .open_amount,
                                                                              scope
                                                                                .row
                                                                                .amount_currency
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                641494869
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.check_all_credit_notes"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .isIndeterminateCreditNotes
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCheckAllCreditNotesChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .checkAllCreditNotes,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.dunningNoticeFormState,
                                                                                  "checkAllCreditNotes",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "dunningNoticeFormState.checkAllCreditNotes"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.selectedCreditNotes.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleCheckedCreditNotesChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                2790979425
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.attach_all_credit_notes"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .isIndeterminateCreditNotesAttachment,
                                                                              disabled:
                                                                                _vm.hasNoSelectedCreditNotesWithAttachments
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleAttachAllCreditNotesChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .checkAllCreditNotesAttachment,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.dunningNoticeFormState,
                                                                                  "checkAllCreditNotesAttachment",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "dunningNoticeFormState.checkAllCreditNotesAttachment"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.attachedCreditNotes.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1,
                                                                              disabled: !scope
                                                                                .row
                                                                                .hasPdfAttachment
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleAttachedCreditNotesChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                2737045355
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.recipientRecord.debit_notes
                                                .length > 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "create-account-overview__debit_notes",
                                                      attrs: {
                                                        prop: "debitNotes"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex justify-between"
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "payment_plan.create.debit_notes"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .dunningNoticeFormState
                                                            .showCheckAllDebitNotes
                                                            ? _c("el-switch", {
                                                                attrs: {
                                                                  "active-text": _vm.$t(
                                                                    "action_detail.show_all_debit_notes"
                                                                  ),
                                                                  "inactive-text": _vm.$t(
                                                                    "action_detail.show_open_debit_notes"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dunningNoticeFormState
                                                                      .showAllDebitNotes,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dunningNoticeFormState,
                                                                      "showAllDebitNotes",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dunningNoticeFormState.showAllDebitNotes"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-table",
                                                        {
                                                          ref:
                                                            "debitNotesTable",
                                                          attrs: {
                                                            data: _vm.debitNotes
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "debit_note_number",
                                                                label: _vm.$t(
                                                                  "debit_note_table.debit_note_number"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "issue_date",
                                                                label: _vm.$t(
                                                                  "debit_note_table.issue_date"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "open_amount",
                                                                label: _vm.$t(
                                                                  "debit_note_table.open_amount"
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$formatter.toCurrency(
                                                                              scope
                                                                                .row
                                                                                .open_amount,
                                                                              scope
                                                                                .row
                                                                                .amount_currency
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                641494869
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.check_all_debit_notes"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .isIndeterminateDebitNotes
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCheckAllDebitNotesChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .checkAllDebitNotes,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.dunningNoticeFormState,
                                                                                  "checkAllDebitNotes",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "dunningNoticeFormState.checkAllDebitNotes"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.selectedDebitNotes.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleCheckedDebitNotesChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                3988468513
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.recipientRecord
                                                .payment_documents.length > 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "create-account-overview__payments",
                                                      attrs: {
                                                        prop: "payments"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex justify-between"
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "action_detail.payments"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm
                                                            .dunningNoticeFormState
                                                            .showCheckAllPayments
                                                            ? _c("el-switch", {
                                                                attrs: {
                                                                  "active-text": _vm.$t(
                                                                    "action_detail.show_all_payments"
                                                                  ),
                                                                  "inactive-text": _vm.$t(
                                                                    "action_detail.show_open_payments"
                                                                  )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .dunningNoticeFormState
                                                                      .showAllPayments,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.dunningNoticeFormState,
                                                                      "showAllPayments",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "dunningNoticeFormState.showAllPayments"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-table",
                                                        {
                                                          ref: "paymentsTable",
                                                          attrs: {
                                                            data: _vm.payments
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "payment_number",
                                                                label: _vm.$t(
                                                                  "payment_table.payment_number"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "issue_date",
                                                                label: _vm.$t(
                                                                  "payment_table.issue_date"
                                                                )
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                prop:
                                                                  "open_amount",
                                                                label: _vm.$t(
                                                                  "payment_table.open_amount"
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$formatter.toCurrency(
                                                                              scope
                                                                                .row
                                                                                .open_amount,
                                                                              scope
                                                                                .row
                                                                                .amount_currency
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                641494869
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-table-column",
                                                            {
                                                              attrs: {
                                                                align: "center"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "header",
                                                                    fn: function({}) {
                                                                      return [
                                                                        _vm._v(
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "action_detail.check_all_payments"
                                                                              )
                                                                            )
                                                                        ),
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              indeterminate:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .isIndeterminatePayments
                                                                            },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCheckAllPaymentsChange
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .dunningNoticeFormState
                                                                                  .checkAllPayments,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.dunningNoticeFormState,
                                                                                  "checkAllPayments",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "dunningNoticeFormState.checkAllPayments"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            attrs: {
                                                                              value:
                                                                                _vm.dunningNoticeForm.selectedPayments.indexOf(
                                                                                  scope
                                                                                    .row
                                                                                    .reference
                                                                                ) !==
                                                                                -1
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleCheckedPaymentsChange(
                                                                                  scope.row
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                3364308510
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "action_detal.dunning_notice_costs"
                                        ),
                                        name: "dunning_notice_costs",
                                        disabled: !_vm.hasEditManualActionCostsPermission
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "span",
                                                  { staticClass: "tab-label" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "action_detal.dunning_notice_costs"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    !_vm.hasEditManualActionCostsPermission
                                                      ? _c("i", {
                                                          staticClass:
                                                            "el-icon-lock"
                                                        })
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        false,
                                        1880171034
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cost-settings" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cost-settings__row"
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.dunningNoticeForm
                                                        .enabledOverrideReminderCosts
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.handleCostSettingsChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dunningNoticeForm
                                                        .enabledDamageClauses,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dunningNoticeForm,
                                                        "enabledDamageClauses",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dunningNoticeForm.enabledDamageClauses"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "action_detail.enable_damage_clauses"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cost-settings__row"
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.dunningNoticeForm
                                                        .enabledOverrideReminderCosts
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.handleCostSettingsChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dunningNoticeForm
                                                        .enabledReminderCosts,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dunningNoticeForm,
                                                        "enabledReminderCosts",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dunningNoticeForm.enabledReminderCosts"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "action_detail.enable_reminder_costs"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cost-settings__override"
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.handleCostSettingsChange(
                                                        true
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dunningNoticeForm
                                                        .enabledOverrideReminderCosts,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dunningNoticeForm,
                                                        "enabledOverrideReminderCosts",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dunningNoticeForm.enabledOverrideReminderCosts"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "action_detail.override_reminder_costs"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.dunningNoticeForm
                                            .enabledOverrideReminderCosts
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cost-settings__inputs"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "cost-settings__field"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "action_detail.reminder_costs"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "160px"
                                                          },
                                                          attrs: {
                                                            size: "small"
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleCostSettingsChange(
                                                                false
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.overrideReminderCostsInput,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.overrideReminderCostsInput = $$v
                                                            },
                                                            expression:
                                                              "overrideReminderCostsInput"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "prepend" },
                                                            [_vm._v("€")]
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showTinyMCEEditor
                        ? [
                            _c(
                              "div",
                              [
                                _vm.action.channel === "MAIL"
                                  ? _c("HtmlRenderer", {
                                      attrs: { content: _vm.tinymcecontent }
                                    })
                                  : _c("editor", {
                                      attrs: {
                                        disabled:
                                          _vm.action &&
                                          (!_vm.editable ||
                                            _vm.action.channel === "MAIL" ||
                                            _vm.action.channel === "SMS"),
                                        "tinymce-script-src":
                                          "https://assets.prod.rslt.be/tinymce/tinymce.min.js",
                                        init: {
                                          height: 500,
                                          menubar: false,
                                          valid_children:
                                            "+body[style],+div[style]",
                                          extended_valid_elements:
                                            "style[type|media|scoped]",
                                          plugins: [
                                            "advlist",
                                            "autolink",
                                            "lists",
                                            "link",
                                            "image",
                                            "charmap",
                                            "preview",
                                            "anchor",
                                            "searchreplace",
                                            "visualblocks",
                                            "code",
                                            "fullscreen",
                                            "insertdatetime",
                                            "media",
                                            "table",
                                            "code",
                                            "help",
                                            "wordcount"
                                          ],
                                          toolbar:
                                            "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment | table tabledelete | tableprops tablerowprops tablecellprops | \
                     tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol"
                                        }
                                      },
                                      on: {
                                        onDirty: _vm.handleOnDirty,
                                        onChange: _vm.handleOnChange,
                                        onFocusIn: _vm.handleOnFocusIn,
                                        onKeyDown: _vm.handleOnKeyDown
                                      },
                                      model: {
                                        value: _vm.tinymcecontent,
                                        callback: function($$v) {
                                          _vm.tinymcecontent = $$v
                                        },
                                        expression: "tinymcecontent"
                                      }
                                    })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRenderedBase64 === false && _vm.hasCoverLetter
                        ? [
                            _c("div", { staticStyle: { width: "1000px" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "disp-inl-block",
                                  staticStyle: {
                                    width: "120px",
                                    height: "190px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "el-form-item__label",
                                      staticStyle: {
                                        "font-weight": "700",
                                        float: "right"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("content")))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "disp-inl-block",
                                  staticStyle: { width: "460px" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui placeholder",
                                      staticStyle: {
                                        width: "100%",
                                        "flex-basis": "100%"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "paragraph" }, [
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "mb-50",
                                    staticStyle: {
                                      width: "100%",
                                      "flex-basis": "100%"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ui placeholder",
                                      staticStyle: {
                                        width: "100%",
                                        "flex-basis": "100%"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "paragraph" }, [
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "line" })
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showAttachmentBlock
                        ? _c(
                            "div",
                            { staticClass: "mt-20" },
                            [
                              _c("h3", [_vm._v(_vm._s(_vm.$t("attachments")))]),
                              _vm._v(" "),
                              _c("attachment-uploader", {
                                attrs: {
                                  attachments: _vm.currentAttachments,
                                  participant: _vm.selectedParticipantStore,
                                  "legal-entity": _vm.action.legal_entity,
                                  loading: _vm.isUploadingAttachment
                                },
                                on: {
                                  "attachment-added": _vm.handleAttachmentAdded,
                                  "attachment-removed":
                                    _vm.handleRemoveAttachment,
                                  loading: _vm.setLoading
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: _vm.rightPanelWidth } },
                [
                  _vm.userInterfaceDetails &&
                  _vm.userInterfaceDetails.custom_field_definitions &&
                  _vm.userInterfaceDetails.custom_field_definitions.length > 0
                    ? [
                        _c(
                          "el-card",
                          { staticClass: "box-card no-shadow mb-5" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header"
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$tc("action", 1)))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _vm.userInterfaceDetails &&
                                _vm.userInterfaceDetails
                                  .custom_field_definitions
                                  ? _c("custom-fields-list", {
                                      attrs: {
                                        "custom-field-definitions":
                                          _vm.userInterfaceDetails
                                            .custom_field_definitions,
                                        "custom-fields":
                                          _vm.action.custom_fields
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mb-10",
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function($event) {
                                        _vm.isShowActionCustomFields = !_vm.isShowActionCustomFields
                                      }
                                    }
                                  },
                                  [
                                    _vm.isShowActionCustomFields
                                      ? [_vm._v(_vm._s(_vm.$t("hideAll")))]
                                      : [_vm._v(_vm._s(_vm.$t("showAll")))]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.isShowActionCustomFields
                                  ? [
                                      _c("json-editor", {
                                        ref: "jsonEditor",
                                        model: {
                                          value: _vm.action.custom_fields,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.action,
                                              "custom_fields",
                                              $$v
                                            )
                                          },
                                          expression: "action.custom_fields"
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentRecipient
                    ? [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "recipientBlock" },
                            [
                              _c(
                                "el-card",
                                { staticClass: "box-card no-shadow mb-5" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$tc("recipient", 1)))
                                      ]),
                                      _vm._v(" "),
                                      _vm.action
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                float: "right",
                                                display: "flex",
                                                "align-items": "center",
                                                gap: "6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "action-detail-recipient-link",
                                                  staticStyle: {
                                                    color: "#4eb0b9",
                                                    "text-decoration": "none"
                                                  },
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.onViewRecipientInNewTab
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(_vm.$t("view")) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "action-detail-new-tab-icon",
                                                  staticStyle: {
                                                    background: "none",
                                                    border: "none",
                                                    padding: "0",
                                                    cursor: "pointer",
                                                    color: "#4eb0b9",
                                                    visibility: "visible"
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click:
                                                      _vm.onViewRecipientInNewTab
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass: "svg-icon",
                                                      staticStyle: {
                                                        width: "1em",
                                                        height: "1em",
                                                        "vertical-align":
                                                          "-0.15em",
                                                        fill: "currentColor",
                                                        overflow: "hidden"
                                                      },
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    },
                                                    [
                                                      _c("use", {
                                                        attrs: {
                                                          href:
                                                            "#icon-up-right-from-square"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fs-13" }, [
                                    _vm.currentRecipient.tags &&
                                    _vm.currentRecipient.tags.length
                                      ? _c(
                                          "div",
                                          { staticClass: "colGrid-2 mb-10" },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(_vm.$t("tags.title"))
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              _vm._l(
                                                _vm.currentRecipient.tags,
                                                function(tag, index) {
                                                  return _c(
                                                    "el-tag",
                                                    {
                                                      key: index,
                                                      staticClass: "mr-5 mb-5",
                                                      attrs: {
                                                        size: "mini",
                                                        type: "info",
                                                        effect: "dark"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$translate.tag(
                                                              tag.tag_name
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "colGrid-2 mb-10" },
                                      [
                                        _c("b", [
                                          _vm._v(_vm._s(_vm.$t("accountId")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mb-10" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentRecipient.account_id
                                                ? _vm.currentRecipient
                                                    .account_id
                                                : "/"
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "colGrid-2 mb-10" },
                                      [
                                        _c("b", [
                                          _vm._v(_vm._s(_vm.$t("name")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mb-10" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentRecipient.name
                                                ? _vm.currentRecipient.name
                                                : "/"
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "colGrid-2 mb-10" },
                                      [
                                        _c("b", [_vm._v("B2B/B2C")]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mb-10" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentRecipient.type
                                                ? _vm.currentRecipient.type
                                                : "/"
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "colGrid-2 mb-10" },
                                      [
                                        _vm.currentRecipient.legal_id
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.$translate.legal_id_type_description(
                                                    _vm.currentRecipient
                                                      .legal_id_type
                                                  )
                                                }
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate.legal_id_type(
                                                        _vm.currentRecipient
                                                          .legal_id_type
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentRecipient.type === "B2B"
                                          ? _c(
                                              "div",
                                              { staticClass: "mb-10" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentRecipient
                                                      .legal_id
                                                      ? _vm.currentRecipient
                                                          .legal_id
                                                      : "/"
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("MainContacts", {
                                    attrs: {
                                      recipient: _vm.currentRecipient.reference,
                                      "legal-entity": _vm.action.legal_entity,
                                      "endpoint-selectable": true,
                                      "on-select-endpoint": endpoint =>
                                        _vm.handleSelectEndpoint(null, endpoint)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-20" }, [
                                    _c(
                                      "div",
                                      { staticClass: "mb-5" },
                                      [
                                        _c("h4", [
                                          _vm._v(
                                            _vm._s(_vm.$t("contactPeople"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.action && _vm.action.recipient
                                          ? [
                                              _c("contacts", {
                                                attrs: {
                                                  recipient:
                                                    _vm.action.recipient,
                                                  "legal-entity":
                                                    _vm.action.legal_entity,
                                                  selectable: true,
                                                  "end-point-selectable": true,
                                                  "pre-selected":
                                                    _vm.preSelectedContacts,
                                                  disabled:
                                                    _vm.disabledContacts,
                                                  "endpoint-selectable": true,
                                                  "on-select":
                                                    _vm.handleSelectEndpoint,
                                                  "on-select-endpoint":
                                                    _vm.handleSelectEndpoint
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lastestActionNotesBlock" },
                            [
                              _c(
                                "el-card",
                                { staticClass: "box-card no-shadow mb-5" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$tc("latestActions", 777))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _vm.action
                                        ? [
                                            _c("actions-notes", {
                                              attrs: {
                                                recipient: _vm.action.recipient,
                                                "legal-entity":
                                                  _vm.action.legal_entity
                                              }
                                            })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "customFieldsBlock" },
                            [
                              _c(
                                "el-card",
                                { staticClass: "box-card no-shadow mb-5" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("customFields")))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "mb-10",
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                _vm.isShowRecipientCustomFields = !_vm.isShowRecipientCustomFields
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("show")))]
                                        ),
                                        _vm._v(" "),
                                        _vm.isShowRecipientCustomFields
                                          ? [
                                              _c("json-editor", {
                                                ref: "jsonEditor",
                                                model: {
                                                  value:
                                                    _vm.customFieldsJsonEditorData,
                                                  callback: function($$v) {
                                                    _vm.customFieldsJsonEditorData = $$v
                                                  },
                                                  expression:
                                                    "customFieldsJsonEditorData"
                                                }
                                              })
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    : [_vm._v("\n\t\t\t\t\tLoading...\n\t\t\t\t")]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }